import * as React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { getData } from '../../../../../../actions/apiCall';
import FormSetup from '../../../../../../components/Forms/FormSetup';
import { MasterConfigs } from '../../../../../../interfaces/entity';
import dayjs from 'dayjs';

const ScheduleInterviewDrawer = ({ isVisible, onClose, id }) => {
    const dispatch = useDispatch();
    const [visible, setVisible] = React.useState(false);
    const [date, setDate] = React.useState(null);
    const [slots, setSlots] = React.useState([]);
    const [interviewer, setInterviewer] = React.useState(null);
    const [duration, setDuration] = React.useState(null);

    React.useEffect(() => {
        setVisible(isVisible)
    }, [isVisible])

    const listSlots = (_interviewer, _day, currentDate, _duration) => `/slots/list/slots/for/${_interviewer}/${_day}/${currentDate}/${_duration}`;

    const onDateChanged = async (_selectedDate) => {
        // setDate(_selectedDate);
        const newDate = moment().subtract(1, 'days');
        if (moment(_selectedDate).isBefore(newDate)) {
            return [];
        } else {
            if (interviewer && _selectedDate && duration) {
                const resData = await dispatch(getData(listSlots(interviewer, dayjs(_selectedDate).format('dddd'), dayjs(_selectedDate), duration)));
                if (resData.code == 200) {
                    setSlots(resData.data);
                } else {
                    setSlots([]);
                }
            }
        }
    };

    React.useEffect(() => {
        if (duration && interviewer && date) {
            onDateChanged(date);
        }
    }, [duration, interviewer, date]);

    const disabledDate = (current) => {
        return current && current < moment().startOf('day');
    };

    const config: MasterConfigs = {
        api: () => '/shortlistedCandidates/book',
        modalTitle: (text) => `Schdule Interview`,
        isActionTab: false,
        getFormColumns: () => {
            return [
                {
                    label: 'First Name',
                    name: 'firstName',
                    type: 'text',
                    inputProps: { disabled: true },
                    rules: [{
                        required: true,
                        message: 'First Name is required'
                    }]
                },
                {
                    label: 'Last Name',
                    name: 'lastName',
                    inputProps: { disabled: true },
                    type: 'text',
                    rules: [{
                        required: true,
                        message: 'Last Name is required'
                    }]
                },
                {
                    label: 'Select interviewer',
                    name: 'interviewer',
                    type: 'select',
                    isCombo: true,
                    selectProps: {
                        onChange: (e) => {
                            setInterviewer(e);
                        }
                    }
                },
                {
                    label: 'Select other interviewer',
                    name: 'otherInterviewer',
                    type: 'select',
                    selectProps: { mode: 'tags' },
                    isCombo: true,
                },
                {
                    label: 'External Interviewer',
                    name: 'externalInterviewer',
                    type: 'text',
                },
                {
                    label: 'Select date',
                    name: 'selectDate',
                    type: 'date',
                    dateProps: {
                        disabledDate: disabledDate,
                        onChange: (e) => {
                            setDate(e);
                        },
                    }
                },
                {
                    label: 'Select Duration',
                    name: 'duration',
                    type: 'select',
                    children: [15, 30, 45, 60, 90].map(e => ({ name: `${e} min`, value: e })),
                    selectProps: {
                        allowClear: true,
                        onChange: (e) => {
                            setDuration(e);
                        },
                    }
                },
                {
                    label: 'Select Slots',
                    name: 'slots',
                    type: 'select',
                    children: slots.map(e => ({ name: e, value: e })),
                },
            ]
        },
        combo: [
            {
                name: 'interviewer',
                api: '/slots/',
                idKey: '_id',
                render: (text) => {
                    return text ? [text.slotsFor.firstName, text.slotsFor.lastName].join(' ') : '';
                },
            },
            {
                name: 'otherInterviewer',
                api: '/users/?includingme=yes',
                idKey: '_id',
                render: (text) => [text.firstName, text.middelNamem, text.lastName].join(' ')
            }
        ],
    };
    return <FormSetup id={id} config={config} open={visible} onClose={() => onClose()} isModal={true} />
};

export default ScheduleInterviewDrawer;